"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentCoverPriceWidget = void 0;
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../commonFunctions");
var CurrentCoverPriceWidget = exports.CurrentCoverPriceWidget = /** @class */ (function (_super) {
    __extends(CurrentCoverPriceWidget, _super);
    function CurrentCoverPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            policies: []
        };
        return _this;
    }
    CurrentCoverPriceWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies().subscribe(function (policies) {
            _this.setState({
                policies: policies
            });
        });
    };
    CurrentCoverPriceWidget.prototype.render = function () {
        if (this.state.policies && this.state.policies.length > 0) {
            var premium = 0;
            var neverHigher = 0;
            for (var _i = 0, _a = this.state.policies; _i < _a.length; _i++) {
                var policy = _a[_i];
                premium += policy.interaction.factors.premium;
                neverHigher += policy.interaction.factors.neverHigher;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "plugin dashboard" },
                    React.createElement("div", { className: "current-cover-widget pt-3" },
                        React.createElement("h2", { className: "inner-container mb-0 text-blue-2" }, "Your current cover"),
                        React.createElement("div", null,
                            React.createElement("div", { className: "content pt-0" },
                                React.createElement("div", { className: "price pb-0 text-blue-2 font-family-display" }, (0, commonFunctions_1.getAmountToDisplay)(premium)),
                                React.createElement("div", { className: "price-text text-blue-2" }, "For your next month"),
                                React.createElement("div", { className: "price pb-0 pt-4 text-blue-2 font-family-display" }, (0, commonFunctions_1.getAmountToDisplay)(neverHigher)),
                                React.createElement("div", { className: "price-text text-blue-2" }, "Your estimated maximum price for the following two months")))))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], CurrentCoverPriceWidget.prototype, "customerPortalService", void 0);
    CurrentCoverPriceWidget = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CurrentCoverPriceWidget);
    return CurrentCoverPriceWidget;
}(React.Component));
//# sourceMappingURL=CurrentCoverPriceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/falconSelfService/CurrentCoverPriceWidget.js
// module id = 3275
// module chunks = 0